<div class="orders pagination-order">
  <header
    *ngIf="orderLineDetailsGridListing.length > 5 && !isFromIpSummary"
    class="orders-header d-flex align-items-center justify-content-between has-border py-2 mb-4">
    <h1>Order Lines Details</h1>
    <div class="orders-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Export-excel me-2"></i>
        <a class="link" (click)="exportExcel()">Export excel</a>
      </div>
    </div>
  </header>

  <p-table
    #dt
    stripedRows
    [rowHover]="true"
    [rows]="25"
    [showCurrentPageReport]="true"
    [scrollable]="true"
    scrollHeight="calc(100vh - 310px)"
    [size]="'small'"
    responsiveLayout="scroll"
    [value]="orderLineDetailsGridListing"
    styleClass="p-datatable-customers"
    [rowHover]="true"
    [rows]="20"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
    [paginator]="orderLineDetailsGridListing.length > 5 && !isFromIpSummary"
    [filterDelay]="0"
    styleClass="table-listing">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th class="number smcolwidth text-center">Line</th>
        <th class="status text-center">PO#</th>
        <th
          class="name trimmedvendorby20char text-center max-width-10 text-truncate">
          Vendor
        </th>
        <th
          [ngClass]="{ trimmedby50char: descriptionCharacterCond }"
          class="jname text-center max-width-10 text-truncate">
          Description
        </th>
        <th class="buyer text-right">Qty</th>
        <th class="inhanddate text-center">Sell</th>
        <th class="date-time text-center">Total Sell</th>
        <th class="subtotal text-center">Net</th>
        <th class="commission text-center">Total Cost</th>
        <th class="gp text-center">GP</th>
        <th *ngIf="showNetCommField" class="currency text-center">Com</th>
        <th class="cust-po text-center">Matched %</th>
        <!-- <th class="bconsultant">Ven Invoice</th> -->
        <th class="bconsultant text-center">Ven Inv Date</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-orderLineDetailsGridListing
      let-rowIndex="rowIndex">
      <tr
        class="p-selectable-row"
        [pSelectableRow]="orderLineDetailsGridListing"
        [pSelectableRowIndex]="rowIndex">
        <td class="number col-center">
          <!-- <a class="link"> </a> -->
          {{ orderLineDetailsGridListing?.lineNumber }}
        </td>
        <td class="number text-center">
          <a class="link" (click)="OpenPoPdf(orderLineDetailsGridListing)">
            {{ orderLineDetailsGridListing?.purchaseOrderNumber }}</a
          >
        </td>
        <td class="status trimmedvendorby20char max-width-10 text-truncate">
          <div
            *ngIf="
              orderLineDetailsGridListing?.vendor.length > 19;
              else showUntrimmedVendor
            ">
            <div class="trimmedvendor">
              {{ orderLineDetailsGridListing?.vendor }}
            </div>
          </div>
          <ng-template #showUntrimmedVendor>
            {{ orderLineDetailsGridListing?.vendor }}
          </ng-template>
        </td>
        <td
          [ngClass]="{
            'trimmeddescription trimmedby50char': descriptionCharacterCond,
          }"
          class="name max-width-10 text-truncate">
          {{ descriptionCharacterCount(orderLineDetailsGridListing.description)
          }}{{ orderLineDetailsGridListing?.description }}
        </td>
        <td class="jname align-right">
          {{ orderLineDetailsGridListing?.qty | number: "0.0-2" }}
        </td>
        <td class="buyer align-right">
          {{
            orderLineDetailsGridListing?.sale
              | currency: "USD" : "symbol" : "0.3-3"
          }}
        </td>
        <td class="inhandate align-right">
          {{
            orderLineDetailsGridListing?.totalSell
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <td class="date-time align-right">
          {{
            orderLineDetailsGridListing?.net
              | currency: "USD" : "symbol" : "0.4-4"
          }}
        </td>
        <td class="subtotal align-right">
          {{
            orderLineDetailsGridListing?.totalCost
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <td class="commission align-right">
          {{
            orderLineDetailsGridListing?.gp
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <td class="gp align-right" *ngIf="showNetCommField">
          {{
            orderLineDetailsGridListing?.comm
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <!-- <td class="currency align-right">
          {{ orderLineDetailsGridListing?.matched | number: '1.2-2' }}%
        </td> -->
        <td class="currency align-right">
          <ng-container
            *ngIf="
              orderLineDetailsGridListing?.matched !== 0.0;
              else blankCell
            ">
            {{ orderLineDetailsGridListing?.matched | number: "1.2-2" }}%
          </ng-container>
        </td>
        <ng-template #blankCell> </ng-template>
        <!-- <td class="currency" (click)="onVendorInvoiceSelection()">
          <a class="link"> {{ orderLineDetailsGridListing?.venInvoice }}</a>
        </td> -->
        <td class="cust-po text-center">
          <span
            *ngIf="orderLineDetailsGridListing?.invoiceDate | hideEmptyDate">
            <a
              class="link"
              (click)="
                openUrlDialog(orderLineDetailsGridListing?.purchaseOrderNumber)
              "
              >{{
                orderLineDetailsGridListing?.invoiceDate | date: "MM-dd-yyyy"
              }}</a
            >
          </span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          colspan="20"
          [ngClass]="{
            orderLineDetailsConsumesMessage: orderLineDetailsConsumesMessage
              .toLowerCase()
              .includes('please wait loading lines'),
          }">
          {{ orderLineDetailsConsumesMessage }}
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="footer">
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="align-right">
          {{ invoicePreviewLines.totalSell | currency: "USD" }}
        </td>
        <td></td>
        <td class="align-right">
          {{ invoicePreviewLines.totalCost | currency: "USD" }}
        </td>
        <td class="align-right">
          {{ invoicePreviewLines.totalGp | currency: "USD" }}
        </td>
        <td class="align-right" *ngIf="showNetCommField">
          {{ invoicePreviewLines.totalComm | currency: "USD" }}
        </td>
        <td></td>
        <td></td>
      </tr>
    </ng-template>
  </p-table>
</div>

<jni-unmatch-url-dialog
  [displayModal]="unmatchQuantityStatus"
  *ngIf="vendorInvoiceJournalDetail?.length"
  (closeDialogEvent)="closeUrlDialog()"
  [vendorInvoiceJournalDetail]="
    vendorInvoiceJournalDetail
  "></jni-unmatch-url-dialog>

<jni-modal-stacker
  *ngIf="poEmailDisplayModal"
  [displayModal]="poEmailDisplayModal"
  (closeEvent)="closeModalForPoEmail()"
  class="modal-header-sticky">
  <h1 class="panelHeading mt-5"></h1>
  <div class="panelBody">
    <jni-po-email
      [poEmailData]="poEmailData"
      (closePOEmailModalEvent)="closeModalForPoEmail()"
      [isModal]="true"
      (closePOEmailModalEvent)="closeModalForPoEmail()"></jni-po-email>
  </div>
</jni-modal-stacker>
